import { StatusScreen } from "@kaltura/mediaspace-shared-ui";
import { addBaseUrl, baseUrl, getDataFromKms, translate } from "@kaltura/mediaspace-shared-utils";
import { useState } from "react";

export function Unregister() {
    const [unregistered, setUnregistered] = useState(false);

    const unregisterUser = () => {
        getDataFromKms(
            addBaseUrl("/unregister?format=script"),
            { confirm: 1 },
            ({ success, error }: { success: boolean; error?: string }) => {
                if (!success) {
                    console.log("failed to unregister user: ", error);
                    return;
                }
                setUnregistered(true);
            },
            false
        );
    };

    return (
        <>
            {!unregistered && (
                <StatusScreen
                    title={translate("Wait!")}
                    text={translate("Are you sure you want to unregister?")}
                    buttonLabel={translate("I want to participate!")}
                    buttonProps={{
                        size: "large",
                        href: baseUrl + "/",
                    }}
                    button2Label={translate("Unregister")}
                    button2Props={{
                        size: "large",
                        onClick: unregisterUser,
                        variant: "borderless",
                        color: "secondary",
                    }}
                />
            )}
            {unregistered && (
                <StatusScreen
                    title={translate("We're sorry to see you go")}
                    text={translate("You are no longer a registered user.")}
                    buttonLabel={translate("Explore Site")}
                    buttonProps={{
                        size: "large",
                        href: baseUrl + "/",
                    }}
                />
            )}
        </>
    );
}

export default Unregister;
